import React, { CSSProperties, ReactNode } from "react";
import { AppButton, AppButtonProps } from "../../atoms/Button";

type ButtonProps = AppButtonProps & { label: ReactNode };

export type ButtonGroupProps = {
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
  align?: CSSProperties["justifyContent"];
  gap?: number;
  style?: CSSProperties;
};

export const ButtonGroup = (props: ButtonGroupProps) => {
  const { primaryButton, secondaryButton, align = "end", gap = 8, style } = props;

  if (!primaryButton && !secondaryButton) return null;

  return (
    <div style={{ display: "flex", width: "100%", justifyContent: align, gap, ...style }}>
      {secondaryButton && (
        <AppButton variant="secondary" {...(({ label, ...rest }) => rest)(secondaryButton)}>
          {secondaryButton.label}
        </AppButton>
      )}

      {primaryButton && (
        <AppButton variant="primary" {...(({ label, ...rest }) => rest)(primaryButton)}>
          {primaryButton.label}
        </AppButton>
      )}
    </div>
  );
};
